// Web Speech API のラッパー（音声→テキスト）
// iOS Safari 14.5+ でも webkitSpeechRecognition として動作

export class Voice {
  constructor() {
    this.recognition = null;
    this.onResult = null;
    this.onError = null;
    this.onEnd = null;
    this.isListening = false;
  }

  isSupported() {
    return !!(window.SpeechRecognition || window.webkitSpeechRecognition);
  }

  start(lang = 'ja-JP') {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) {
      if (this.onError) this.onError(new Error('お使いのブラウザは音声認識に対応していません'));
      return;
    }
    if (this.recognition) this.stop();

    const r = new SR();
    r.lang = lang;
    r.continuous = false;
    r.interimResults = false;
    r.maxAlternatives = 1;

    r.onresult = (event) => {
      const transcript = event.results?.[0]?.[0]?.transcript || '';
      if (this.onResult) this.onResult(transcript);
    };
    r.onerror = (event) => {
      this.isListening = false;
      const msg = mapError(event.error) || '音声認識エラー';
      if (this.onError) this.onError(new Error(msg));
    };
    r.onend = () => {
      this.isListening = false;
      if (this.onEnd) this.onEnd();
    };

    this.recognition = r;
    this.isListening = true;
    try {
      r.start();
    } catch (err) {
      this.isListening = false;
      if (this.onError) this.onError(err);
    }
  }

  stop() {
    if (this.recognition) {
      try { this.recognition.stop(); } catch {}
      this.recognition = null;
    }
    this.isListening = false;
  }
}

function mapError(code) {
  switch (code) {
    case 'not-allowed':
    case 'service-not-allowed':
      return 'マイクの使用が許可されていません。設定で許可してください。';
    case 'no-speech':
      return '音声を検出できませんでした。もう一度お試しください。';
    case 'audio-capture':
      return 'マイクにアクセスできませんでした。';
    case 'network':
      return 'ネットワークエラーで音声認識に失敗しました。';
    default:
      return null;
  }
}
